import { render, staticRenderFns } from "./cozy-gaming-page.vue?vue&type=template&id=2f5801b2&lang=pug&"
import script from "./cozy-gaming-page.vue?vue&type=script&lang=js&"
export * from "./cozy-gaming-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports